import { createFileRoute } from '@tanstack/react-router'
import { Link, useTranslation } from '@ufc/core'
import { isRtlLanguage } from '@ufc/portal-shared'
import { Button, Home, Search, ArrowLeft } from '@ufc/uikit'

export const Route = createFileRoute('/$')({
  component: NotFoundPage,
})

function NotFoundPage() {
  const { t, i18n } = useTranslation()
  const isRTL = isRtlLanguage(i18n.language)

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Background gradients */}
      <div className="fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-br from-primary/30 via-transparent to-transparent rounded-full blur-3xl" />
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-tl from-accent/20 via-transparent to-transparent rounded-full blur-3xl" />
        <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />
      </div>

      <div className="text-center px-4">
        {/* 404 Animation */}
        <div className="relative mb-8">
          <h1 className="text-[12rem] font-bold text-primary/10 leading-none select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="glass-card rounded-2xl px-8 py-4">
              <Search className="h-16 w-16 text-primary mx-auto" />
            </div>
          </div>
        </div>

        <h2 className="text-3xl font-bold text-foreground mb-4">
          {t('error.pageNotFound')}
        </h2>
        <p className="text-lg text-muted-foreground mb-8 max-w-md mx-auto">
          {t('error.pageNotFoundDesc')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg">
            <Link to="/">
              <Home className="h-4 w-4 mr-2 rtl:mr-0 rtl:ml-2" />
              {t('error.goHome')}
            </Link>
          </Button>
          <Button variant="outline" size="lg" onClick={() => window.history.back()}>
            <ArrowLeft className="h-4 w-4 mr-2 rtl:mr-0 rtl:ml-2 rtl:rotate-180" />
            {t('error.goBack')}
          </Button>
        </div>

        <div className="mt-12 glass rounded-xl p-6 max-w-md mx-auto">
          <h3 className="font-medium text-foreground mb-2">
            {t('error.lookingFor')}
          </h3>
          <ul className="text-sm text-muted-foreground space-y-1">
            <li>
              <Link to="/" className="text-primary hover:underline">
                {t('sidebar.overview')}
              </Link>
              {' - '}{t('error.dashboardHint')}
            </li>
            <li>
              <Link to="/orders" className="text-primary hover:underline">
                {t('sidebar.orders')}
              </Link>
              {' - '}{t('error.ordersHint')}
            </li>
            <li>
              <Link to="/contracts" className="text-primary hover:underline">
                {t('sidebar.contracts')}
              </Link>
              {' - '}{t('error.contractsHint')}
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
